import React from "react"
import "./testimonialsPartner.scss"

const TESTIMONIALS = [
  {
    name: "Rajesh Kumar",
    city: "Delhi NCR",
    text: "We run 8 Sedans on the Delhi-Agra-Jaipur corridor. Since attaching with Pulpit, we get consistent outstation bookings without spending on marketing. The weekly payout cycle is reliable and the Partner Dashboard makes tracking easy.",
    rating: 5,
  },
  {
    name: "Sunil Patil",
    city: "Mumbai",
    text: "As a fleet owner with 15 cabs, Pulpit handles all the customer acquisition so I can focus on operations. The toll pass-through at actuals is fair, and the 30-day trial gave us confidence before fully committing.",
    rating: 5,
  },
  {
    name: "Arun Sharma",
    city: "Bangalore",
    text: "I attached my Innova for outstation trips on Pulpit. The onboarding was quick - documents verified in 2 days. Now I get Bangalore-Mysuru and Bangalore-Coimbatore bookings regularly without any effort on marketing.",
    rating: 5,
  },
]

const TestimonialsPartner = () => {
  return (
    <section className="testimonials-partner">
      <div className="testimonials-partner__container">
        <h2 className="testimonials-partner__heading">
          What Our Cab Drivers <span>Say</span>
        </h2>
        <p className="testimonials-partner__subheading">
          Real stories from drivers and fleet owners who drive and earn with Pulpit
        </p>
        <div className="testimonials-partner__grid">
          {TESTIMONIALS.map((t, i) => (
            <div className="testimonials-partner__card" key={i}>
              <div className="testimonials-partner__stars">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <svg key={j} width="18" height="18" viewBox="0 0 24 24" fill="#E05A49">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                  </svg>
                ))}
              </div>
              <p className="testimonials-partner__text">{t.text}</p>
              <div className="testimonials-partner__author">
                <div className="testimonials-partner__avatar">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="testimonials-partner__name">{t.name}</p>
                  <p className="testimonials-partner__city">{t.city}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TestimonialsPartner
